// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('productMoveChoices', {
//         templateUrl: 'views/components/views/productMoveChoices/productMoveChoices.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'productMoveChoicesService', 'ttGridFactory', function ($stateParams, productMoveChoicesService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let prodId = $stateParams.prod_id;
            
//             vm.model = {
//                 gridReady: false,
//                 setting: {}
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'w_productmovechoices_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await productMoveChoicesService.getProductMoveChoices({ prod_id: prodId }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 2892,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
